(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Ringmaat"] && !Shopify.designMode) return;
  try {
    
function openRingmaatSidebar() {
  document.body.classList.add('ringmaat-open');
}
function closeRingmaatSidebar() {
  document.body.classList.remove('ringmaat-open');
}
window.addEventListener("click", function(e) {
  const modal = document.querySelector('.ringmaat-sidebar');
  if (e.target === modal) {
    closeRingmaatSidebar();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
